import {
    commonDialog,
    commonProgressDialog,
    commonToast,
    useDialog,
    useProgressDialog,
    useToast,
} from 'app/shared/context/CommonUIProvider'
import { Button } from 'primereact/button'
import * as React from 'react'

const PgCommonUI: React.FC = () => {
    const { show: toastShow, hide: toastHide } = useToast()
    const showToast = () => {
        toastShow({
            severity: 'error',
            content: 'hook - 계좌 복사를 실패 했어요.',
        })
    }
    const showToastFun = () => {
        commonToast({
            severity: 'error',
            content: 'func - 계좌 복사를 실패 했어요.',
        })
    }

    const { show, hide } = useDialog()
    const testChildren = (
        <p className="p-quote">
            유효한 촬영시간이 경과되었습니다.
            <br />
            잠시 후 얼굴 촬영을 다시
            <br />
            시도해주세요.
        </p>
    )
    const showAlert = () => {
        show({
            title: 'hook - 계좌개설을 종료합니다',
            children: testChildren,
            onHide: () => {},
            accept: () => {},
            acceptLabel: 'OK',
        })
    }
    const showConfirm = () => {
        show({
            title: 'hook - 5분 뒤 퇴근합니다. 이 창은 5초 뒤 닫힙니다.',
            children: testChildren,
            onHide: () => {},
            accept: () => {
                toastShow({
                    severity: 'success',
                    content: '칼퇴!',
                })
            },
            acceptLabel: '칼퇴',

            reject: () => {
                toastShow({
                    severity: 'error',
                    content: '야근!',
                })
            },
            rejectLabel: '야근',
        })
        setTimeout(() => {
            hide()
        }, 5000)
    }

    const showConfirmFun = () => {
        const hideFun = commonDialog({
            title: 'func - 5분 뒤 퇴근합니다. 이 창은 5초 뒤 닫힙니다.',
            children: testChildren,
            onHide: () => {},
            accept: () => {
                toastShow({
                    severity: 'success',
                    content: '칼퇴!',
                })
            },
            acceptLabel: '칼퇴',

            reject: () => {
                toastShow({
                    severity: 'error',
                    content: '야근!',
                })
            },
            rejectLabel: '야근',
        })
        setTimeout(() => {
            hideFun()
        }, 5000)
    }

    const { show: showLoadingDialog, hide: hideLoadingDialog } =
        useProgressDialog()
    const showLoading = () => {
        showLoadingDialog()
        setTimeout(hideLoadingDialog, 5000)
    }
    const showLoadingFun = () => {
        setTimeout(commonProgressDialog(), 5000)
    }
    return (
        <div style={{ padding: '1em' }}>
            <Button
                className="button-basic-tint -md width-full mt-24"
                label="토스트 - Hook"
                onClick={showToast}
            />
            <br />
            <Button
                className="button-basic-tint -md width-full mt-24"
                label="토스트 - function"
                onClick={showToastFun}
            />
            <br />
            <Button
                className="button-basic-tint -md width-full mt-24"
                label="Alert - Hook"
                onClick={showAlert}
            />
            <br />
            <Button
                className="button-basic-tint -md width-full mt-24"
                label="Confirm - Hook"
                onClick={showConfirm}
            />
            <br />
            <Button
                className="button-basic-tint -md width-full mt-24"
                label="Confirm - function"
                onClick={showConfirmFun}
            />
            <br />
            <Button
                className="button-basic-tint -md width-full mt-24"
                label="Loading - Hook"
                onClick={showLoading}
            />
            <br />
            <Button
                className="button-basic-tint -md width-full mt-24"
                label="Loading - function"
                onClick={showLoadingFun}
            />
        </div>
    )
}

export default PgCommonUI
